"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = formatDate;
function formatDate({ date }) {
    const dateString = new Date(date);
    const dateObj = new Date(dateString);
    const publishedDate = dateObj.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
    return publishedDate;
}
